import { AddressDirectiveModule } from '@b2b/common/directives/address/address.directive';
import { ApiService } from '@b2b/common/services/api/types';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { PartnersCreateCreateEditAddressModalControllerModule } from './controllers/CreateEditAddressModalController';

export const PartnersCreateView = angular
  .module('acme.view.application.partners.create', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.directive.paymentOptions',
    AddressDirectiveModule,
    'acme.view.application.partners.create.controllers',
    'acme.view.application.partners.edit.controllers',
    'acme.view.application.partners.create.manageSecondaryContactModal.controllers',
    'acme.view.application.partners.create.removeSecondaryContactModal.controllers',
    PartnersCreateCreateEditAddressModalControllerModule,
    'acme.view.application.partners.create.selectAddressModal.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.partners.create',
      url: '/create?categoryId',
      views: {
        'subview-main': {
          controller: 'PartnersCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/partners/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Organization',
      },
      resolve: {
        CategoriesData: [
          'ApiService',
          function (ApiService: ApiService) {
            return ApiService.partners.categories.list({
              page: 1,
              pageSize: -1,
              sortDirection: 'asc',
              sortField: 'name',
            });
          },
        ],
      },
    });

    $stateProvider.state({
      name: 'application.partners.edit',
      url: '/edit?accountId',
      views: {
        'subview-main': {
          controller: 'PartnersEditController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/partners/create/edit.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Organization',
        enablePreferences: true,
      },
      resolve: {
        CategoriesData: [
          'ApiService',
          function (ApiService: ApiService) {
            return ApiService.partners.categories.list({
              page: 1,
              pageSize: -1,
              sortDirection: 'asc',
              sortField: 'name',
            });
          },
        ],
      },
    });
  }).name;
